/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useState } from 'react'
import { ListView } from 'antd-mobile'
import * as _ from 'lodash'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON } from '@constants/index'
import { CompanyPickLikeActivityListItem } from '@views/MyPage/UserActivity/LikeActivity/CompanyPickLikeActivity/CompanyPickLikeActivityListItem'
import { CompanyPickLikeActivityListWrap } from '@views/MyPage/index.style'
import { useOnMount } from '@utils/reactExt'
import useRootStore from '@store/useRootStore'

interface CompanyPickLikeActivityProps {
  baseMonth?: string
}

// 프리미엄 분석가
export const CompanyPickLikeActivity: React.FC<CompanyPickLikeActivityProps> = observer((props) => {
  const [hasMore, setHasMore] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const { companyPickStore } = useRootStore()
  const {
    companyPicks = [],
  } = companyPickStore

  const dataSource = new ListView.DataSource({
    rowHasChanged: (row1, row2) => row1 !== row2,
  })

  useOnMount(() => {
      fetch(true)
  })

  const endReachedHandler = async () => {
    if (isLoading) {
      return
    }

    if (hasMore) {
      await fetch()
    }
  }

  const fetch = async (reset = false) => {
    try {
      setIsLoading(true)

      const params = {
        offset: reset ? 0 : _.size(companyPicks),
        baseMonth: props?.baseMonth,
      }
      const result = await companyPickStore.api.companyPick.fetchCompanyPickMyLikedList(params)
      let newCompanyPicks = result.items
      if (!reset) {
        newCompanyPicks = _.concat(companyPicks, result.items)
      }
      companyPickStore.setCompanyPicks(newCompanyPicks)
      setHasMore(result.hasMore)
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  const renderRow = row => {
    return (
      <CompanyPickLikeActivityListItem companyPick={row}/>
    )
  }

  const renderFooter = (): React.ReactElement => {
    let footer
    if (_.size(companyPicks) > 0) {
      footer = <Fragment/>
    } else {
      footer = <AdvEmpty ico={EMPTY_ICON.USER_PICK_LIKE_ACTIVITY}/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  return (
    <CompanyPickLikeActivityListWrap>
      <ListView
        css={{ height: '100%' }}
        dataSource={dataSource.cloneWithRows(companyPicks ?? [])}
        renderRow={renderRow}
        scrollRenderAheadDistance={500}
        onEndReached={endReachedHandler}
        renderFooter={renderFooter}
        onEndReachedThreshold={10}
        initialListSize={12}
        pageSize={20}
      />
    </CompanyPickLikeActivityListWrap>
  )
})
